function SocialFrame({ children, href }: any) {
  return (
    <div
      className="flex justify-center items-center w-[308px] h-[88px] relative bg-[#090910] z-50 cursor-pointer"
      onClick={()=>{href ? window.open(href, '_blank'):0;}}
    >
      {children}
      <div className="absolute">
        <svg
          width={308}
          height={88}
          viewBox="0 0 308 88"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_bi_246_46330)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M24.2894 0.830445V0H308V88H0V20.0419H0.586551L23.8105 0.352299L24.2894 0.830445ZM24.8127 1.3822H306.498V86.6178H1.50244V21.145L24.8127 1.3822Z"
              fill="#090918"
              fillOpacity="0.05"
            />
            <path
              d="M24.8127 1.3822H306.498V86.6178H1.50244V21.145L24.8127 1.3822Z"
              fill="#090918"
              fillOpacity="0.05"
            />
            <path
              d="M23.8479 1.27277L23.9064 1.3312L1.09826 20.6683L0.877439 20.8555V21.145V86.6178V87.2428H1.50244H306.498H307.123V86.6178V1.3822V0.757199H306.498H24.9144V0.625H307.375V87.375H0.625V20.6669H0.815837L0.990727 20.5186L23.7759 1.20096L23.8479 1.27277ZM2.12744 21.4345L24.7941 2.21736L24.9144 2.33748V2.11535L25.042 2.0072H305.873V85.9928H2.12744V21.4345Z"
              stroke="#22222F"
              strokeOpacity="0.6"
              strokeWidth="1.25"
            />
          </g>
          <g filter="url(#filter1_di_246_46330)">
            <rect x={285} y={16} width={2} height={2} fill="#2589FF" />
            <rect x={284} y={15} width={4} height={4} stroke="black" strokeWidth={2} />
          </g>
          <g filter="url(#filter2_di_246_46330)">
            <rect x={285} y={69} width={2} height={2} fill="#2589FF" />
            <rect x={284} y={68} width={4} height={4} stroke="black" strokeWidth={2} />
          </g>
          <g filter="url(#filter3_di_246_46330)">
            <rect x={20} y={69} width={2} height={2} fill="#2589FF" />
            <rect x={19} y={68} width={4} height={4} stroke="black" strokeWidth={2} />
          </g>
          <defs>
            <filter
              id="filter0_bi_246_46330"
              x="-4.8"
              y={-7}
              width="317.6"
              height="99.8"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feGaussianBlur in="BackgroundImageFix" stdDeviation="2.4" />
              <feComposite
                in2="SourceAlpha"
                operator="in"
                result="effect1_backgroundBlur_246_46330"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_backgroundBlur_246_46330"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy={-7} />
              <feGaussianBlur stdDeviation="8.8" />
              <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.145098 0 0 0 0 0.537255 0 0 0 0 1 0 0 0 0.05 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect2_innerShadow_246_46330"
              />
            </filter>
            <filter
              id="filter1_di_246_46330"
              x={279}
              y={14}
              width={14}
              height={14}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy={4} />
              <feGaussianBlur stdDeviation={2} />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_246_46330"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_246_46330"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy={3} />
              <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.17 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect2_innerShadow_246_46330"
              />
            </filter>
            <filter
              id="filter2_di_246_46330"
              x={279}
              y={67}
              width={14}
              height={14}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy={4} />
              <feGaussianBlur stdDeviation={2} />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_246_46330"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_246_46330"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy={3} />
              <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.17 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect2_innerShadow_246_46330"
              />
            </filter>
            <filter
              id="filter3_di_246_46330"
              x={14}
              y={67}
              width={14}
              height={14}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy={4} />
              <feGaussianBlur stdDeviation={2} />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_246_46330"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_246_46330"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy={3} />
              <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.17 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect2_innerShadow_246_46330"
              />
            </filter>
          </defs>
        </svg>
      </div>
    </div>
  );
}

export default SocialFrame;